import { isMindshiftGuide } from '@/utils/guides';
import { MediaGuideMetadata } from '@/utils/media/types';
import { ProgramContextState } from '@rhg/hooks/use-program-context/types';

/**
 * Per-row Play/Pause CTA toggling applies to Music Album, Sleep Story
 * Playlist, DTC Course and DTC Program rows. Clinical, Mindshift and Dailies
 * rows keep their fixed primary CTA (lottie indicator only).
 */
export function isCtaToggleEligible(
    guide: MediaGuideMetadata,
    programType: ProgramContextState['programType']
): boolean {
    if (programType === 'clinical_program') {
        return false;
    }
    if (isMindshiftGuide(guide)) {
        return false;
    }
    if (guide.dailyContentType) {
        return false;
    }
    return true;
}
